'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const header = css`
  display: grid;
  gap: 0.5rem;
  grid-template-areas:
    'title actions'
    'user .';
  @media screen and (width > ${theme.sizes.screens.md}) {
    gap: 1rem;
  }
`;

export const title = css`
  grid-area: title;
  font-size: 18px;
  font-weight: 600;
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 24px;
    font-weight: 700;
  }
`;

export const description = css`
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.peoople['gris-medio-claro']};
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 16px;
  }
`;

export const user = css`
  grid-area: user;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 0;
`;

export const actions = css`
  grid-area: actions;
  > div {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: flex-end;
  }
`;

export const nickname = css`
  font-weight: 600;
`;
